import React, { useState } from 'react';
import { db } from '../../services/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const FeedbackComponent = ({ featureId, userId }) => {
const [submitted, setSubmitted] = useState(false);

const handleFeedback = async (rating) => {
try {
await addDoc(collection(db, 'feedback'), {
featureId: featureId || 'general',
rating,
timestamp: serverTimestamp(),
userId: userId,
});
setSubmitted(true);
} catch (error) {
console.error('Error submitting feedback:', error);
}
};

if (submitted) {
return <p className="text-green-600 mt-2">Thanks for your feedback!</p>;
}

return (
<div className="max-w-sm p-4 rounded-2xl shadow-md border border-gray-200 bg-white m-auto mt-8">
{submitted ? (
<p className="text-green-600 text-sm text-center">Thanks for your feedback! 🎉</p>
) : (
<div className="flex flex-col items-center gap-3">
<p className="text-gray-700 text-sm">How are you liking DrillFlo?</p>
<div className="flex gap-4">
<button
onClick={() => handleFeedback('up')}
className="text-2xl transition-transform duration-150 hover:scale-110 active:scale-95"
aria-label="Thumbs up"
>
👍
</button>
<button
onClick={() => handleFeedback('down')}
className="text-2xl transition-transform duration-150 hover:scale-110 active:scale-95"
aria-label="Thumbs down"
>
👎
</button>
</div>
</div>
)}
</div>
);
};

export default FeedbackComponent;